export default {
    documentStatus: {
        complete: 'Completo',
        pending: 'Pendiente',
        error: 'Error',
    },
    containerStatus: {
        draft: 'Borrador',
        booked: 'Reservado',
        inTransit: 'En Tránsito',
        arrived: 'Llegado',
        delivered: 'Entregado',
        onHold: 'En Espera',
        cancelled: 'Cancelado',
    },
    // Estado físico del contenedor (modelo 2025)
    containerPhysicalStatus: {
        PENDING: 'Pendiente',
        GATE_OUT_EMPTY: 'Salida Gate (Vacío)',
        LOADING: 'Cargando',
        GATE_IN: 'Entrada Gate',
        LOAD_ON_VESSEL: 'Cargado en Buque',
        VESSEL_DEPARTED: 'Buque Partió',
        IN_TRANSIT: 'En Tránsito',
        VESSEL_ARRIVED: 'Buque Llegó',
        DISCHARGED: 'Descargado',
        GATE_OUT_DELIVERY: 'Salida Gate (Entrega)',
        DELIVERED: 'Entregado',
        ON_HOLD: 'En Espera',
        CANCELLED: 'Cancelado',
    },
    // Estado de reserva
    bookingStatus: {
        DRAFT: 'Borrador',
        CONFIRMED: 'Confirmado',
        IN_PROGRESS: 'En Progreso',
        COMPLETED: 'Completado',
        CANCELLED: 'Cancelado',
    },
    riskLevel: {
        low: 'Bajo',
        medium: 'Medio',
        high: 'Alto',
        critical: 'Crítico',
    },
    documentType: {
        billOfLading: 'Conocimiento de Embarque',
        invoice: 'Factura Comercial',
        phytosanitaryCertificate: 'Certificado Fitosanitario',
        movementCertificate: 'Certificado EUR.1',
        packingList: 'Lista de Empaque',
        fumigationCertificate: 'Certificado de Fumigación',
        sadIcm: 'SAD/ICM',
        coo: 'Certificado de Origen',
        unknown: 'Documento Desconocido',
    },
    roles: {
        shipper: 'Exportador',
        consignee: 'Consignatario',
        receiver: 'Destinatario',
        notifyParty: 'Parte Notificada',
        freightForwarder: 'Agente de Carga',
        forwarder: 'Expedidor',
        carrier: 'Transportista Marítimo',
        shipOwner: 'Armador',
        landTransport: 'Transporte Terrestre',
        customsBroker: 'Aduana',
        portOfLoading: 'Puerto de Embarque',
        portOfDischarge: 'Puerto de Desembarque',
        airportStaff: 'Personal del Aeropuerto',
        authority: 'Autoridad',
        insuranceProvider: 'Proveedor de Seguros',
        inspectionAgency: 'Agencia de Inspección',
        sales: 'Ventas',
        supplier: 'Proveedor',
    },
    status: {
        active: 'Activo',
        pending: 'Pendiente',
        rejected: 'Rechazado',
        suspended: 'Suspendido',
        inactive: 'Inactivo',
        accepted: 'Aceptado',
        modified: 'Modificado',
        confirmed: 'Confirmado',
        cancelled: 'Cancelado',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Visualizador',
    },
};

